// SCADA colour readers — a small CSS-variable reader scoped to the
// energy-flow diagram's domain palette.
//
// Mirrors the `readVar` pattern from `src/lib/chartTheme.ts`: every getter
// resolves an `--ems-*` custom property at call time, so the SCADA diagram
// adapts automatically when [data-theme="dark"] flips — no `isDark()`
// branching, no module-load snapshot.
//
// Usage: call the getters inside render (`scada.charge()`), never hoist the
// result to module scope, or the theme switch won't take effect.

import { readVar } from "@/lib/chartTheme";

export const scada = {
  gridImport: () => readVar("--ems-grid-import"),     // grid power flowing in (violet)
  gridExport: () => readVar("--ems-grid-export"),     // power flowing out / site loads (green)
  charge: () => readVar("--ems-charge"),              // BESS charging (blue)
  discharge: () => readVar("--ems-discharge"),        // BESS discharging (amber)
  solar: () => readVar("--ems-solar"),                // PV generation
  idle: () => readVar("--ems-ink-muted"),             // idle / inactive grey
  brand: () => readVar("--ems-brand"),                // EMS hub
  ok: () => readVar("--ems-ok"),                      // healthy / tracking green
  warn: () => readVar("--ems-warn"),                  // fault / degraded amber
  critical: () => readVar("--ems-alarm-critical"),    // alarm / offline red
} as const;
